import React, { useEffect, useState } from 'react'
import Cards from "./DashBoardsCards"
import axios from 'axios'
import apiClient from '../../utils/apiclient'

const Dashboard = () => {
  const [count, SetCount] = useState([])
  useEffect(() => {
    const count = async () => {
      try {
        const data = await apiClient.get("/getCounts");
        SetCount(data.data)
        console.log(data)
      }
      catch (e) {
        console.error(e);
      }

    }
    count();
  }, [])
  const [oneTimeOrdersCount, SetoneTimeOrdersCount] = useState({
    "name": "Total One_time Orders",
    "values": "1"
  })
  return (
    <div className="w-full">
      <h2 className="text-base md:text-xl font-semibold text-gray-800 mb-2">
        Dashboard Overview
      </h2>
      <div className="flex overflow-x-auto gap-2 pb-2 md:grid md:grid-cols-7 md:overflow-visible [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">     {Object.entries(count).map(([key, value], index) => (
        <Cards key={index} data={{ title: key, count: value }} />
      ))}
      </div>
    </div>
  )
}

export default Dashboard